import React from 'react';
import { PictoProps } from './index';

export const Search = (props: PictoProps) => (
  <svg
    width={props.width || '21'}
    height={props.height || '20'}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9.44434"
      cy="9"
      r="8"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4442 19L15.0942 14.65"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
